import { useState } from "react";
import { CircularProgress, IconButton, InputAdornment, TextField } from "@material-ui/core";

/**
 * @see https://v4.mui.com/components/text-fields/
 */
const CustomInput = ({
    variant,
    type,
    label,
    margin,
    name,
    handleBlur,
    handleChange,
    handleFocus,
    value,
    errors,
    touched,
    placeholder,
    required,
    disabled,
    InputProps,
    inputProps,
    style,
    readOnly,
    multiline,
    minRows,
    maxRows,
    inheritLabel,
    loadingCEP,
    helperText,
    error,
    refs,
    className,
    autoFocus,
    inputClassName,
    fullWidth,
    counter = false,
    counterStyle = {},
    maxLength,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const endAdornment = () => {
        if (loadingCEP) {
            return (
                <InputAdornment position="end">
                    <CircularProgress size={15} />
                </InputAdornment>
            );
        } else if (name?.includes("password")) {
            return (
                <InputAdornment position="end">
                    <IconButton
                        onClick={(e) => {
                            e.preventDefault();
                            setShowPassword(!showPassword);
                        }}
                    >
                        <i className={showPassword ? "far fa-eye-slash" : "far fa-eye"} style={{ color: "#6B7280", fontSize: 15 }} />
                    </IconButton>
                </InputAdornment>
            );
        }
    };

    const maxLen = maxLength ?? (name?.includes("cep") || name?.includes("postalcode") ? 9 : name?.includes("telefone") || name?.includes("phone") ? 15 : name?.includes("cnpj") ? 18 : name?.includes("cpf") ? 14 : multiline ? 63000 : 250);

    return (
        <div className={`d-flex flex-column gap-8 ${className ?? ""}${counter ? " position-relative w-100" : ""}`}>
            {label &&
                !inheritLabel &&
                (typeof label === "string" ? (
                    <span title={label} className="tt-14 medium color-dark-7 overflow-ellipsis w-100" htmlFor={name}>
                        {label}
                        {required ? <span className="color-red"> *</span> : ""}
                    </span>
                ) : (
                    label
                ))}

            <TextField
                ref={refs}
                variant={variant ?? "outlined"}
                type={type || (name?.includes("password") && !showPassword ? "password" : "text")}
                required={required}
                label={inheritLabel && label ? label : null}
                margin={margin ?? "dense"}
                className="mb-0"
                style={{ margin: 0, marginTop: inheritLabel ? 24 : 0, ...style }}
                name={name}
                onBlur={handleBlur}
                onChange={handleChange}
                onFocus={handleFocus}
                value={value}
                helperText={(helperText ?? (name && touched && errors && touched[name])) ? errors[name] : null}
                error={error || (name && touched && errors) ? Boolean(touched[name] && errors[name]) : false}
                placeholder={placeholder}
                InputProps={{
                    ...{ endAdornment: endAdornment() },
                    ...InputProps,
                }}
                inputProps={{
                    ...{
                        maxLength: maxLen,
                        className: inputClassName,
                    },
                    ...inputProps,
                }}
                disabled={disabled}
                readOnly={readOnly}
                multiline={multiline}
                minRows={minRows}
                maxRows={maxRows}
                autoFocus={autoFocus}
                autoComplete="off"
                fullWidth={fullWidth}
            />

            {counter ? (
                <span className="tt-12 color-dark-7 position-absolute" style={{ right: 8, bottom: -8, padding: "0px 4px", ...counterStyle }}>
                    {(value ?? "").length}/{maxLen}
                </span>
            ) : null}
        </div>
    );
};

export default CustomInput;
